import { render, staticRenderFns } from "./RateioDeDespesas.vue?vue&type=template&id=052460c0&"
import script from "./RateioDeDespesas.vue?vue&type=script&lang=js&"
export * from "./RateioDeDespesas.vue?vue&type=script&lang=js&"
import style0 from "./RateioDeDespesas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RateioDeDespesas.vue"
export default component.exports